<template>
  <div class="charge-detail">
    <div v-if="charge && charge.stageChargeDetails">
      <ul v-for="s in charge.stageChargeDetails" :key="s.startTime">
        <li v-for="p in s.periods" :key="p.actualStart" class="charge-detail-period">
          <div class="charge-detail-time"><van-icon name="clock" /> {{p.actualStart | datetime('MM月DD日HH:mm:ss')}} - {{p.actualEnd | datetime('MM月DD日HH:mm:ss')}}</div>
          <div class="charge-detail-content">
            <span class="charge-detail-content-left">
              <div>{{p.actualTime|duration}}</div>
              <div>{{p.ruleDesc}}</div>
            </span>
            <span class="charge-detail-content-right">{{p.fee}}元</span>
          </div>
        </li>
      </ul>
      <div class="charge-detail-sum">合计: {{charge.totalCharge}}元</div>
    </div>
  </div>
  
</template>
<script>
import { Icon } from 'vant'
export default {
  name: 'ChargeDetail',
  components: {
    [Icon.name] : Icon
  },
  props: {
    charge : Object
  }
}
</script>
<style lang="less" scoped>
.charge-detail-period {
  margin: 15px 10px;
}
.charge-detail-content {
  display: flex;
  justify-content: space-between;
  padding-left: 15px;
}
.charge-detail-content-left{
  font-size: 14px;
  color: gray;
}
.charge-detail-content-right{
  text-align: right;
  font-size: 20px;
  font-weight:bold;
}
.charge-detail-time {
  font-family: Consolas, Monaco, Menlo, 'Courier New', Courier, monospace;
  font-size: 13px;
  font-weight: bold;
  color: darkblue;
}
.charge-detail-sum{
  text-align: right;
  font-size: 26px;
  font-weight:bold;
  padding-right: 10px;
}
</style>